module.exports = __webpack_public_path__ + "static/media/buggy-half.416bdb3f.png";